import {baseUrl, GET_REPROT_REASON_ERROR} from "../../../constants";


export const getReportReasons = async () => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(`${baseUrl}/flag-reasons`, {
            headers: new Headers({
                "x-access-token": user.accessToken,
                "Content-Type": "application/json"
            }),
        }
        );
        if (!response.ok) throw response;
        const responseJson = await response.json();
        return responseJson;
    } catch (error) {
        throw GET_REPROT_REASON_ERROR;
    }
}

